import type { ProfileType, PropertyCountRangeType } from '@zg-rentals/ts-rental-manager-api-beta-client';

export const STEPS = {
  NAME: 'NAME',
  PROFILE_TYPE: 'PROFILE_TYPE',
  PROPERTY_COUNT: 'PROPERTY_COUNT',
  PROPERTY_DETAILS: 'PROPERTY_DETAILS',
  PROPERTY_CONFIRMATION: 'PROPERTY_CONFIRMATION',
  THANKS: 'THANKS',
} as const;

export type StepType = (typeof STEPS)[keyof typeof STEPS];

export type UserProfile = {
  firstName: string;
  lastName: string;
  profileType: ProfileType | null;
  propertyCountRange: PropertyCountRangeType | null;
};
